import React from 'react';
import BaseLink from '../../sisu/button/BaseLink.sisu';

const NeoLink = (props) => {
  return (<>
    <BaseLink {...props}/>
  </>);
};

export default NeoLink;